import React from "react";
import {
  Box,
  Typography,
  Card,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import AppButton from "../../../../components/buyer/AppButton";
import { capitalizeFirst } from "../../../../utils/stringUtils";

const ORDER_STATUS_LABELS = {
  pending: "Pending",
  accepted: "Accepted",
  matched: "Matched",
  completed: "Completed",
  rejected: "Rejected",

  admin_review: "Admin Review",
  awaiting_extra_payment: "Awaiting Extra Payment",
};

const PAYMENT_STATUS_LABELS = {
  pending: "Pending",
  paid: "Paid",
  failed: "Failed",
  refunded: "Refunded",
};

const getStatusLabel = (status, map) => {
  if (!status) return "-";

  return (
    map?.[status] ||
    status
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase())
  );
};

const RecentOrdersSection = ({ orders, onPay, theme, onRowClick }) => (
  <Card
    sx={{
      p: { xs: 3, sm: 5 }, // Adjust padding for mobile and larger screens
      mb: 8,
      borderRadius: 3,
      background: "#f9fff9",
      border: "1px solid rgba(0,0,0,0.05)",
      boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
    }}
  >
    <Typography
      variant="h5"
      fontWeight={600}
      mb={3}
      sx={{
        fontSize: { xs: "1.2rem", sm: "1.5rem" }, // Adjust font size for smaller screens
      }}
    >
      Recent Orders
    </Typography>
    <Box sx={{ overflowX: "auto" }}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            {["Order ID", "Product", "Status", "Date", "Action", "Payment"].map(
              (h) => (
                <TableCell key={h} align="center" sx={{ fontWeight: 600 }}>
                  {h}
                </TableCell>
              ),
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {orders.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} align="center">
                <Typography variant="body2" color="text.secondary">
                  No recent orders.
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            orders.map((order) => (
              <TableRow
                key={order.id}
                style={{ cursor: "pointer" }}
                onClick={() => onRowClick(order.id)}
                sx={{
                  "&:hover": {
                    backgroundColor: "rgba(0,0,0,0.02)",
                  },
                }}
              >
                <TableCell align="center">{order.id}</TableCell>
                <TableCell align="center">{order.product}</TableCell>
                <TableCell align="center">
                  <Box
                    sx={{
                      background: order.statusColor,
                      color: theme.palette.getContrastText(order.statusColor),
                      borderRadius: 1,
                      px: 1.5,
                      py: 0.5,
                      display: "inline-block",
                      fontWeight: 600,
                    }}
                  >
                    {getStatusLabel(order.status, ORDER_STATUS_LABELS)}
                  </Box>
                </TableCell>
                <TableCell align="center">{order.date}</TableCell>
                <TableCell align="center">
                  {order.status === "accepted" &&
                  order.paymentStatus !== "paid" ? (
                    <AppButton
                      onClick={(e) => {
                        e.stopPropagation();
                        onPay(order.id);
                      }}
                      sx={{ fontSize: { xs: "0.8rem", sm: "1rem" } }}
                    >
                      Pay now
                    </AppButton>
                  ) : (
                    "-"
                  )}
                </TableCell>
                <TableCell align="center">
                  <Box
                    sx={{
                      background:
                        order.paymentStatus === "paid"
                          ? "#d4edda"
                          : order.paymentStatus === "pending"
                            ? "#fff3cd"
                            : "#f8d7da",
                      borderRadius: 1,
                      px: 1.5,
                      py: 0.5,
                      fontWeight: 500,
                      display: "inline-block",
                    }}
                  >
                    {getStatusLabel(order.paymentStatus, PAYMENT_STATUS_LABELS)}
                  </Box>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </Box>
  </Card>
);

export default RecentOrdersSection;
